import DantesShell from "@/components/DantesShell";
import { getDantesContent } from "@/content/dantes";
import { useLang } from "@/context/LanguageContext";
import { usePageMeta } from "@/hooks/usePageMeta";

export default function DantesPricingPage() {
  const { lang } = useLang();
  const copy = getDantesContent(lang);
  usePageMeta("Dantes Pricing", copy.pricing.subtitle);

  return (
    <DantesShell section="pricing">
      <section className="mx-auto max-w-[1240px] px-6 py-16 md:px-10 md:py-24">
        <p className="font-sans text-[11px] uppercase tracking-[0.18em] text-[var(--gold)]">
          Pricing
        </p>
        <h1 className="mt-4 max-w-[12ch] font-serif text-[clamp(2.8rem,7vw,5.5rem)] leading-[0.92]">
          {copy.pricing.title}
        </h1>
        <p className="mt-6 max-w-[54ch] font-sans text-[16px] leading-8 text-[var(--text-secondary)]">
          {copy.pricing.subtitle}
        </p>

        <div className="mt-12 border-t border-[var(--rule)]">
          {copy.pricing.plans.map(([plan, label, text], index) => (
            <div
              key={plan}
              className={`grid gap-5 border-b border-[var(--rule)] py-6 md:grid-cols-[180px_180px_minmax(0,1fr)] ${index === 2 ? "bg-[rgba(158,138,90,0.06)]" : ""}`}
            >
              <div>
                <p className="font-serif text-[32px] text-[var(--text-primary)]">{plan}</p>
              </div>
              <div className="font-sans text-[11px] uppercase tracking-[0.16em] text-[var(--gold)]">
                {label}
              </div>
              <div className="font-sans text-[15px] leading-8 text-[var(--text-secondary)]">{text}</div>
            </div>
          ))}
        </div>

        <div className="mt-12 grid gap-8 border-t border-[var(--rule)] pt-8 md:grid-cols-2">
          <div>
            <p className="font-sans text-[10px] uppercase tracking-[0.16em] text-[var(--text-tertiary)]">
              Value metric
            </p>
            <p className="mt-3 font-sans text-[15px] leading-8 text-[var(--text-primary)]">
              Dantes pricing is anchored to live analyses, document workload, export value, and collaborative desk usage instead of vague “AI credits.”
            </p>
          </div>
          <div>
            <p className="font-sans text-[10px] uppercase tracking-[0.16em] text-[var(--text-tertiary)]">
              Upgrade path
            </p>
            <p className="mt-3 font-sans text-[15px] leading-8 text-[var(--text-primary)]">
              Free proves the workflow, Pro supports the solo operator, Team unlocks shared work, and Enterprise adds governance, procurement, and dedicated controls.
            </p>
          </div>
        </div>
      </section>
    </DantesShell>
  );
}
